import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import AgentRow from 'broker/views/components/Deprecating/AgentRow'
import RemoveAgentModal from 'broker/views/components/Deprecating/RemoveAgentModal'
import { createFilter } from 'react-search-input'


import { selectAccountAgents, selectAccountSearchTerm } from 'broker/selectors/account'


const KEYS_TO_FILTERS = ['name']

const AgentList = (props) => {
  const { agents, searchTerm } = props

  const renderRow = (agent, idx) => {
    return <AgentRow
      agent={agent}
      idx={idx}
      key={agent.id}
      {...props}
    />
  }

  const filteredAgents = agents ? agents.filter(createFilter(searchTerm, KEYS_TO_FILTERS)) : []

  return (
    <div>
      <div className="AgentList">
        <div className="AgentList__body">
          { filteredAgents.map(renderRow) }
        </div>
      </div>
      <RemoveAgentModal/>
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
  agents: selectAccountAgents,
  searchTerm: selectAccountSearchTerm
})

export default connect(mapStateToProps)(AgentList)
